import { COUNTRIES } from '@/utils/constants'
/** mutation types */
const set_error_id = 'set_error_id'
const set_userTheme = 'set_userTheme'
const set_slideShow = 'set_slideShow'
const set_activeCountry = 'set_activeCountry'
const set_secondaryCountry = 'set_secondaryCountry'
const set_viewType = 'set_viewType'
const set_sideNavCollapse = 'set_sideNavCollapse'
const set_filterCurrency = 'set_filterCurrency'
const set_unreadMessages = 'set_unreadMessages'
/** state */
const getDefaultState = () => {
  return {
    errorId: '',
    userTheme: '',
    hasShownSlideShow: false,
    activeCountry: '',
    secondaryCountry: '',
    viewType: 'grid',
    sideNavCollapse: false,
    filterCurrency: '',
    unreadMessages: []
  }
}
const state = getDefaultState()
/** mutations */
const mutations = {
  [set_error_id] (state, data) {
    state.errorId = data
  },
  [set_activeCountry] (state, data) {
    state.activeCountry = data
  },
  [set_userTheme] (state, data) {
    state.userTheme = data
  },
  [set_slideShow] (state) {
    state.hasShownSlideShow = true
  },
  [set_secondaryCountry] (state, data) {
    state.secondaryCountry = data
  },
  [set_viewType] (state, data) {
    state.viewType = data
  },
  [set_sideNavCollapse] (state, data) {
    state.sideNavCollapse = data
  },
  [set_filterCurrency] (state, data) {
    state.filterCurrency = data
  },
  [set_unreadMessages] (state, data) {
    state.unreadMessages = data
  },
  resetState (state) {
    Object.assign(state, getDefaultState())
  }
}

const actions = {
  resetCommonState ({ commit }) {
    commit('resetState')
  },
  setError: ({ commit }, data) => {
    commit('set_error_id', data)
  },
  setUserTheme: ({ commit }, data) => {
    commit('set_userTheme', data)
  },
  initTheme ({ commit }) {
    const cachedTheme = localStorage.theme || false
    //  `true` if the user has set theme to `dark` on browser/OS
    const userPrefersDark = window.matchMedia(
      '(prefers-color-scheme: dark)'
    ).matches
    if (cachedTheme) commit('set_userTheme', `${cachedTheme}-theme`)
    else if (userPrefersDark) commit('set_userTheme', 'dark-theme')
    else commit('set_userTheme', 'light-theme')
  },
  setSlideShowToFalse: ({ commit }) => {
    commit('set_slideShow')
  },
  setActiveCountry: ({ commit }, data) => {
    commit('set_activeCountry', data)
  },
  setSecondaryCountry: ({ commit }, data) => {
    commit('set_secondaryCountry', data)
  },
  setActiveCurrency: ({ commit }, data) => {
    const currency = COUNTRIES.find((country) => country.currency === data)
    commit('set_activeCountry', currency.name)
  },
  setSecondaryCurrency: ({ commit }, data) => {
    const currency = COUNTRIES.find((country) => country.currency === data)
    commit('set_secondaryCountry', currency.name)
  },
  setViewType: ({ commit }, payload) => {
    commit('set_viewType', payload)
  },
  setSideNavCollapse: ({ commit }, payload) => {
    commit('set_sideNavCollapse', payload)
  },
  setFilterCurrency: ({ commit }, payload) => {
    commit('set_filterCurrency', payload)
  },
  setUnreadMessages: ({ commit }, payload) => {
    commit('set_unreadMessages', payload)
  }
}
export default {
  namespaced: true,
  state,
  mutations,
  actions
}
